module.exports = __webpack_public_path__ + "static/media/logo.22d3a223.png";